import { _ as __rest } from '../../tslib.es6-C8rd5pYo.mjs';
import { ServiceIcon, Icon } from '@zapier/design-system';
import { clsx } from 'clsx';
import React, { useContext } from 'react';
import { TagGroupContext, Tag } from 'react-aria-components';

const root = "_root_mhk2s_1";
const titleLabelWrapper = "_title-label-wrapper_mhk2s_85";
const title = "_title_mhk2s_85";
const label = "_label_mhk2s_116";
const styles = {
	root: root,
	titleLabelWrapper: titleLabelWrapper,
	title: title,
	label: label
};

const SelectionChip = (_a) => {
  var _b, _c, _d;
  var { children, className, id, isDisabled = false, label, size: sizeFromProps = "small", style, textValue, title, variant: variantFromProps = "primary" } = _a, props = __rest(_a, ["children", "className", "id", "isDisabled", "label", "size", "style", "textValue", "title", "variant"]);
  const tagGroupContext = useContext(TagGroupContext);
  const size = (_b = tagGroupContext.size) !== null && _b !== void 0 ? _b : sizeFromProps;
  const variant = (_c = tagGroupContext.variant) !== null && _c !== void 0 ? _c : variantFromProps;
  const getTextValue = () => {
    if (textValue)
      return textValue;
    return label ? `${title} ${label}` : title;
  };
  return React.createElement(Tag, Object.assign({}, props, { className: clsx(className, styles.root), "data-selectable": (_d = tagGroupContext === null || tagGroupContext === void 0 ? void 0 : tagGroupContext.selectionMode) !== null && _d !== void 0 ? _d : void 0, "data-size": size, "data-variant": variant, "data-zds": true, id, isDisabled, style, textValue: getTextValue() }), (tagRenderProps) => React.createElement(
    React.Fragment,
    null,
    typeof children === "function" ? children(tagRenderProps) : children,
    title && React.createElement(
      "div",
      { className: styles.titleLabelWrapper, "data-zds": true },
      React.createElement("span", { className: styles.title, "data-zds": true }, title),
      React.createElement("span", { className: styles.label, "data-zds": true }, label)
    )
  ));
};
const SelectionChipServiceIcon = ({ serviceName, src }) => React.createElement(ServiceIcon, { hasBorder: false, size: "large", serviceName, src });
const SelectionChipIcon = ({ name }) => React.createElement(Icon, { name });

export { SelectionChip, SelectionChipIcon, SelectionChipServiceIcon };
//# sourceMappingURL=SelectionChip.es.js.map
